import { RhinoProgram } from '../../../data/program/type';
import { ONE_HOUR_MILLISECONDS, ONE_MINUTE_MILLISECONDS } from '../../../dateTime';

type Params = {
  programs: RhinoProgram[];
  startDate: number;
  endDate: number;
  channelId: number;
};

// TODO Cover with unit tests
export function addNotFoundPrograms({ programs, startDate, endDate, channelId }: Params) {
  if (programs.length === 0) return getNotFoundPrograms(startDate, endDate, channelId);

  const programsWithNotFound: RhinoProgram[] = [];
  for (let i = 0; i < programs.length; i++) {
    const program = programs[i];
    if (i === 0) {
      if (program.startDate - startDate >= ONE_MINUTE_MILLISECONDS) {
        programsWithNotFound.push(...getNotFoundPrograms(startDate, program.startDate, channelId));
      }
    } else {
      const previousProgram = programs[i - 1];
      if (program.startDate - previousProgram.endDate >= ONE_MINUTE_MILLISECONDS) {
        programsWithNotFound.push(...getNotFoundPrograms(previousProgram.endDate, program.startDate, channelId));
      }
    }

    programsWithNotFound.push(program);
  }

  if (endDate - programs[programs.length - 1].endDate >= ONE_MINUTE_MILLISECONDS) {
    programsWithNotFound.push(...getNotFoundPrograms(programs[programs.length - 1].endDate, endDate, channelId));
  }

  return programsWithNotFound;
}

// generates sequence of not found programs from `startDate` to `endDate`
function getNotFoundPrograms(startDate: number, endDate: number, channelId: number): RhinoProgram[] {
  let currentProgramStartDate = startDate;
  let currentProgramEndDate = startDate;
  const programs: RhinoProgram[] = [];

  do {
    currentProgramEndDate = Math.min(
      endDate,
      currentProgramEndDate + Math.floor((2 + Math.random()) * ONE_HOUR_MILLISECONDS),
    );

    programs.push({
      // id should be stable based on startDate/endDate
      // Just sum could be non-unique, find out better way to generate?
      id: currentProgramStartDate + currentProgramEndDate,
      externalId: String(currentProgramStartDate + currentProgramEndDate),
      channelId,
      title: '',
      name: '',
      images: [],
      type: 'program',
      startDate: currentProgramStartDate,
      endDate: currentProgramEndDate,
      isNotFound: true,
    });

    currentProgramStartDate = currentProgramEndDate;
  } while (currentProgramStartDate < endDate);

  return programs;
}
